import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './useAuth.js';
import { hadSession } from '../lib/sessionMarker.js';

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen supports-[height:100dvh]:min-h-dvh items-center justify-center bg-edal-navy-50">
        <div className="rounded-lg border border-edal-navy-200 bg-white px-6 py-4 text-edal-navy-600">
          טוען...
        </div>
      </div>
    );
  }

  if (!user) {
    // ⚠ הכתובת המלאה, ולא רק `pathname` (אלי 04/10/2026: „מיילים לא נשלחים ללינק
    // הנכון"). קישור מהמייל — `/app/projects?project=260250&tab=engineering` —
    // נפתח בטלפון בלי סשן, עבר בכניסה, ונחת על `/app/projects` בלי הפרויקט:
    // ה-query נזרק כאן. כמעט כל התראה נושאת את היעד שלה ב-query.
    // UX X1: מי שהיה מחובר ולא יצא — הסשן פג (לילה, שרת שהתחלף). מסך הכניסה
    // אומר את זה ומחזיר לכאן.
    return <Navigate to="/app/login" state={{ from: location.pathname + location.search + location.hash, expired: hadSession() }} replace />;
  }

  return <>{children}</>;
}
